module.exports = __webpack_public_path__ + "img/dise.5a1cdfd2.png";